import { render, staticRenderFns } from "./termsPage.vue?vue&type=template&id=64eb71ba&scoped=true&"
import script from "./termsPage.vue?vue&type=script&lang=js&"
export * from "./termsPage.vue?vue&type=script&lang=js&"
import style0 from "./termsPage.vue?vue&type=style&index=0&id=64eb71ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64eb71ba",
  null
  
)

export default component.exports